import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  PerplayStatisticsApi,
  PerplayStatisticsControllerDtoMarketVehicleRequest,
  PerplayStatisticsControllerDtoMarketVehicleBoxRequest,
  PerplayStatisticsControllerDtoMarketItemRequest,
  PerplayStatisticsControllerDtoMarketGemRequest,
  PerplayStatisticsControllerDtoUserRequest,
  PerplayStatisticsControllerDtoItemRequest,
  PerplayStatisticsControllerDtoNftCarRequest,
  PerplayStatisticsControllerDtoNftLevelStatRequest,
  PerplayStatisticsControllerDtoNftBoxRequest,
  PerplayStatisticsControllerDtoTokenRequest,
  PerplayStatisticsControllerDtoSummaryRequest,
  // PerplayStatisticsControllerDtoTokenStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoMarketCarStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoMarketBoxStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoMarketItemStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoMarketGemStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoNftCarStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoNftBoxStatisticsExcelRequest,
  // PerplayStatisticsControllerDtoTotalCarLevelDistributionExcelRequest,
  // PerplayStatisticsControllerDtoTotalCarStatDistributionExcelRequest,
  // PerplayStatisticsControllerDtoItemStatisticsExcelRequest,
  PerplayStatisticsControllerDtoMarketItemResponse,
  PerplayStatisticsControllerDtoMarketGemResponse,
} from '../../models/src';
import {
  STATISTICS_CAR_BOX_LIST_REQUEST,
  STATISTICS_CAR_LIST_REQUEST,
  STATISTICS_GEM_LIST_REQUEST,
  STATISTICS_ITEMS_LIST_REQUEST,
  STATISTICS_ITEM_ITEMS_LIST_REQUEST,
  STATISTICS_USER_LIST_REQUEST,
  STATISTICS_NFT_CAR_LIST_REQUEST,
  STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST,
  STATISTICS_NFT_BOX_LIST_REQUEST,
  STATISTICS_TOKEN_LIST_REQUEST,
  STATISTICS_SUMMARY_LIST_REQUEST,
  // STATISTICS_TOKEN_EXCEL_DATA_REQUEST,
  // STATISTICS_CAR_EXCEL_DATA_REQUEST,
  // STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST,
  // STATISTICS_ITEMS_EXCEL_DATA_REQUEST,
  // STATISTICS_GEM_EXCEL_DATA_REQUEST,
  // STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST,
  // STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST,
  // STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST,
  // STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST,
  // STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST,
} from '../../constants/monitoring/statisticsConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import PerplayStatisticsControllerDtoMarketVehicleResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketVehicleResponse';
import PerplayStatisticsControllerDtoMarketVehicleBoxResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse';
// import PerplayStatisticsControllerDtoMarketItemResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketItemResponse';
// import PerplayStatisticsControllerDtoMarketGemResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketGemResponse';
import PerplayStatisticsControllerDtoUserResponse from '../../models/src/model/PerplayStatisticsControllerDtoUserResponse';
import PerplayStatisticsControllerDtoItemResponse from '../../models/src/model/PerplayStatisticsControllerDtoItemResponse';
import PerplayStatisticsControllerDtoNftCarResponse from '../../models/src/model/PerplayStatisticsControllerDtoNftCarResponse';
import PerplayStatisticsControllerDtoNftLevelStatResponse from '../../models/src/model/PerplayStatisticsControllerDtoNftLevelStatResponse';
import PerplayStatisticsControllerDtoNftBoxResponse from '../../models/src/model/PerplayStatisticsControllerDtoNftBoxResponse';
import PerplayStatisticsControllerDtoTokenResponse from '../../models/src/model/PerplayStatisticsControllerDtoTokenResponse';
import PerplayStatisticsControllerDtoSummaryResponse from '../../models/src/model/PerplayStatisticsControllerDtoSummaryResponse';
// import PerplayStatisticsControllerDtoTokenStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoTokenStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoMarketCarStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketCarStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoMarketBoxStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketBoxStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoMarketGemStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoMarketGemStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoNftCarStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoNftCarStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoNftBoxStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoNftBoxStatisticsExcelResponse';
// import PerplayStatisticsControllerDtoTotalCarLevelDistributionExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoTotalCarLevelDistributionExcelResponse';
// import PerplayStatisticsControllerDtoTotalCarStatDistributionExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoTotalCarStatDistributionExcelResponse';
// import PerplayStatisticsControllerDtoItemStatisticsExcelResponse from '../../models/src/model/PerplayStatisticsControllerDtoItemStatisticsExcelResponse';

const api = new PerplayStatisticsApi(config.API_CLIENT);

// 요약
function* statisticsSummaryListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoSummaryRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsSummaryPost(
      { perplayStatisticsControllerDtoSummaryRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoSummaryResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// 재무

// 토큰
function* statisticsTokenListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoTokenRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.transactionType = payload.transactionType;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsTokenPost(
      { perplayStatisticsControllerDtoTokenRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoTokenResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsTokenExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoTokenStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsTokenStatisticsExcelPost(
//       {
//         perplayStatisticsControllerDtoTokenStatisticsExcelRequest: requestData,
//       },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoTokenStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

// 마켓
function* statisticsCarListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData =
      new PerplayStatisticsControllerDtoMarketVehicleRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.nftType = payload.nftType;
    requestData.nftGrade = payload.nftGrade;
    requestData.nftSeal = payload.nftSeal;
    requestData.isPlus = payload.isPlus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsMarketVehiclePost(
      { perplayStatisticsControllerDtoMarketVehicleRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoMarketVehicleResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsCarExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoMarketCarStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result =
//       yield api.apiPerplayStatisticsMarketNftCarStatisticsExcelPost(
//         {
//           perplayStatisticsControllerDtoMarketCarStatisticsExcelRequest:
//             requestData,
//         },
//         () => {},
//       );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoMarketCarStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* statisticsCarBoxListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData =
      new PerplayStatisticsControllerDtoMarketVehicleBoxRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.boxType = payload.boxType;
    requestData.boxGrade = payload.boxGrade;
    requestData.isPlus = payload.isPlus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsMarketVehicleBoxPost(
      { perplayStatisticsControllerDtoMarketVehicleBoxRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoMarketVehicleBoxResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsCarBoxExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoMarketBoxStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result =
//       yield api.apiPerplayStatisticsMarketNftBoxStatisticsExcelPost(
//         {
//           perplayStatisticsControllerDtoMarketBoxStatisticsExcelRequest:
//             requestData,
//         },
//         () => {},
//       );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoMarketBoxStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* statisticsItemsListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoMarketItemRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.itemType = payload.itemType;
    requestData.itemLevel = payload.itemLevel;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsMarketItemPost(
      { perplayStatisticsControllerDtoMarketItemRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoMarketItemResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsItemsExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoMarketItemStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsMarketItemStatisticsExcelPost(
//       {
//         perplayStatisticsControllerDtoMarketItemStatisticsExcelRequest:
//           requestData,
//       },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoMarketItemStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* statisticsGemListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoMarketGemRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.gemType = payload.gemType;
    requestData.gemLevel = payload.gemLevel;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsMarketGemPost(
      { perplayStatisticsControllerDtoMarketGemRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoMarketGemResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsGemExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoMarketGemStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsMarketGemStatisticsExcelPost(
//       {
//         perplayStatisticsControllerDtoMarketGemStatisticsExcelRequest:
//           requestData,
//       },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoMarketGemStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

// NFT
function* statisticsNFTCarListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoNftCarRequest();
    requestData.nftType = payload.nftType;
    requestData.nftGrade = payload.nftGrade;
    requestData.nftSeal = payload.nftSeal;
    requestData.isPlus = payload.isPlus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsNftCarPost(
      { perplayStatisticsControllerDtoNftCarRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoNftCarResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsNFTCarExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoNftCarStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsNftStatisticsExcelPost(
//       {
//         perplayStatisticsControllerDtoNftCarStatisticsExcelRequest: requestData,
//       },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoNftCarStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* statisticsNFTLevelStatListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoNftLevelStatRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsNftLevelStatPost(
      { perplayStatisticsControllerDtoNftLevelStatRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoNftLevelStatResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsNFTLevelExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoTotalCarLevelDistributionExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result =
//       yield api.apiPerplayStatisticsTotalCarLevelDistributionExcelPost(
//         {
//           perplayStatisticsControllerDtoTotalCarLevelDistributionExcelRequest:
//             requestData,
//         },
//         () => {},
//       );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoTotalCarLevelDistributionExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

// function* statisticsNFTStatExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoTotalCarStatDistributionExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result =
//       yield api.apiPerplayStatisticsTotalCarStatDistributionExcelPost(
//         {
//           perplayStatisticsControllerDtoTotalCarStatDistributionExcelRequest:
//             requestData,
//         },
//         () => {},
//       );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoTotalCarStatDistributionExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

function* statisticsNFTBoxListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoNftBoxRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.boxType = payload.boxType;
    requestData.boxGrade = payload.boxGrade;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsNftBoxPost(
      { perplayStatisticsControllerDtoNftBoxRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoNftBoxResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsNFTBoxExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoNftBoxStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsNftBoxStatisticsExcelPost(
//       {
//         perplayStatisticsControllerDtoNftBoxStatisticsExcelRequest: requestData,
//       },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoNftBoxStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

// 아이템
function* statisticsItemItemsListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoItemRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.itemType = payload.itemType;
    requestData.gemType = payload.gemType;
    requestData.level = payload.level;
    requestData.isGem = payload.isGem;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsItemPost(
      { perplayStatisticsControllerDtoItemRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoItemResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

// function* statisticsItemItemsExcelDataRequestSaga(payload) {
//   console.assert(payload.callback, {
//     message: 'callback이 설정되지 않았습니다.',
//   });
//
//   try {
//     const requestData =
//       new PerplayStatisticsControllerDtoItemStatisticsExcelRequest();
//     requestData.beginDate = payload.beginDate;
//     requestData.endDate = payload.endDate;
//     requestData.isGem = payload.isGem;
//     console.log('요청 데이터: ', requestData);
//
//     const result = yield api.apiPerplayStatisticsItemStatisticsExcelPost(
//       { perplayStatisticsControllerDtoItemStatisticsExcelRequest: requestData },
//       () => {},
//     );
//     const data = api.apiClient.deserialize(
//       result,
//       PerplayStatisticsControllerDtoItemStatisticsExcelResponse,
//     );
//
//     if (data.resultCode !== 200) {
//       throw new Error(getErrorMessage(data));
//     }
//
//     payload.callback(data);
//   } catch (e) {
//     payload.error(e);
//   }
// }

// 유저
function* statisticsUserListRequestSagas(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayStatisticsControllerDtoUserRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayStatisticsUserPost(
      { perplayStatisticsControllerDtoUserRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      result,
      PerplayStatisticsControllerDtoUserResponse,
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* statisticsRootSaga() {
  yield all([
    // 요약
    takeEvery(
      STATISTICS_SUMMARY_LIST_REQUEST,
      statisticsSummaryListRequestSaga,
    ),
    // 토큰
    takeEvery(STATISTICS_TOKEN_LIST_REQUEST, statisticsTokenListRequestSaga),
    // takeEvery(
    //   STATISTICS_TOKEN_EXCEL_DATA_REQUEST,
    //   statisticsTokenExcelDataRequestSaga,
    // ),
    // 마켓
    takeEvery(STATISTICS_CAR_LIST_REQUEST, statisticsCarListRequestSagas),
    // takeEvery(
    //   STATISTICS_CAR_EXCEL_DATA_REQUEST,
    //   statisticsCarExcelDataRequestSaga,
    // ),
    takeEvery(
      STATISTICS_CAR_BOX_LIST_REQUEST,
      statisticsCarBoxListRequestSagas,
    ),
    // takeEvery(
    //   STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST,
    //   statisticsCarBoxExcelDataRequestSaga,
    // ),
    takeEvery(STATISTICS_ITEMS_LIST_REQUEST, statisticsItemsListRequestSagas),
    // takeEvery(
    //   STATISTICS_ITEMS_EXCEL_DATA_REQUEST,
    //   statisticsItemsExcelDataRequestSaga,
    // ),
    takeEvery(STATISTICS_GEM_LIST_REQUEST, statisticsGemListRequestSagas),
    // takeEvery(
    //   STATISTICS_GEM_EXCEL_DATA_REQUEST,
    //   statisticsGemExcelDataRequestSaga,
    // ),
    // 아이템
    takeEvery(
      STATISTICS_ITEM_ITEMS_LIST_REQUEST,
      statisticsItemItemsListRequestSagas,
    ),
    // takeEvery(
    //   STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST,
    //   statisticsItemItemsExcelDataRequestSaga,
    // ),
    // 유저 (유저 엑셀 요청은 하나의 API 데이터로 처리)
    takeEvery(STATISTICS_USER_LIST_REQUEST, statisticsUserListRequestSagas),
    // NFT
    takeEvery(STATISTICS_NFT_CAR_LIST_REQUEST, statisticsNFTCarListRequestSaga),
    // takeEvery(
    //   STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST,
    //   statisticsNFTCarExcelDataRequestSaga,
    // ),
    takeEvery(
      STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST,
      statisticsNFTLevelStatListRequestSaga,
    ),
    // takeEvery(
    //   STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST,
    //   statisticsNFTLevelExcelDataRequestSaga,
    // ),
    // takeEvery(
    //   STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST,
    //   statisticsNFTStatExcelDataRequestSaga,
    // ),
    takeEvery(STATISTICS_NFT_BOX_LIST_REQUEST, statisticsNFTBoxListRequestSaga),
    // takeEvery(
    //   STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST,
    //   statisticsNFTBoxExcelDataRequestSaga,
    // ),
  ]);
}

const statisticsSagas = [fork(statisticsRootSaga)];

export default statisticsSagas;
